import { getPath } from '@/router/common'

const baseUrl = {
  title: '客户资料模板管理',
  path: 'CustomerInformationTemplate'
}

export default [
  {
    path: getPath('CustomerInformationTemplateMana', baseUrl),
    name: 'CustomerInformationTemplateMana',
    component: () => import(/* webpackChunkName: "CustomerInformationTemplateMana" */ '@/views/customerInformationTemplate/customerInformationTemplateMana/index.vue'),
    meta: {
      title: '客户资料模板管理'
    }
  },
  {
    path: getPath('CustomerInformationTemplateEdit', baseUrl),
    name: 'CustomerInformationTemplateEdit',
    component: () => import(/* webpackChunkName: "CustomerInformationTemplateEdit" */ '@/views/customerInformationTemplate/customerInformationTemplateEdit/index.vue'),
    meta: {
      title: '客户资料模板管理新增编辑'
    }
  }
]
